document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    var parallaxImage = document.querySelector(".parallax-image");
    var scrolled = window.pageYOffset;
    parallaxImage.style.transform =
      "translateX(" +
      scrolled * 0.5 +
      "px)"; /* Adjust the speed by changing the multiplier */
  });
});
